import {SearchResultsProcessor} from '@formbird/shared';
// import { isEmpty, orderBy } from 'lodash';
import * as _ from 'lodash';
import { UtilString} from '@formbird/shared';

const logger = console;
declare var $;
export class DataTableSearch {

  dataTable: any;
  response: any;
  searchInterval: any;
  searchDelay: number;
  handlebars: any;
  queryService: any;
  config: any;
  prevSortScore: any;
  totalHits: number;
  maxItems = 10000;
  prevSort: any;

  constructor(
    dataTable: any,
    configService: any,
    datatablesQueriesService: any,
    handlebars: any) {

    this.dataTable = dataTable;
    this.response = {
      draw: 0,
      recordsTotal: 0,
      recordsFiltered: 0,
      data: [],
      error: null
    };
    this.searchInterval = 0;
    this.searchDelay = 200;
    this.handlebars = handlebars;
    this.config = configService;
    this.queryService = datatablesQueriesService;
  }

  searchBox(events, dt) {
    let searchVal = $(events.target).val();
    clearTimeout(this.searchInterval);
    this.searchInterval = setTimeout(() => {
      searchVal = searchVal.substring(0, dt.SEARCH_LENGTH_LIMIT);
      logger.info(`Search Text has been truncated to '${searchVal}'.`);
      dt.table.search(searchVal).draw();
    }, this.searchDelay);
  }

  async getPit(){
    const pitPromise = await this.dataTable.httpClient.get(`api/generatePit`).toPromise();

    return pitPromise;
/*
    const pit = await this.dataTable.searchService.generatePit();
    return pit;*/
  }

  search(sSource, aoData, fnCallback, pSelect?) {
    this.dataTable.dtSource = sSource;
    this.dataTable.dtData = aoData;

    const draw = $.grep(aoData, (v) => v.name === 'draw')[0].value;
    const columns = $.grep(aoData, (v) => v.name === 'columns')[0].value;
    const order = $.grep(aoData, (v) => v.name === 'order')[0].value;
    const start = $.grep(aoData, (v) => v.name === 'start')[0].value;
    const length = $.grep(aoData, (v) => v.name === 'length')[0].value;
    const search = $.grep(aoData, (v) => v.name === 'search')[0].value;


    const isFiltered = columns.find((col) => {
      return col.search.value !== '';
    });

    if( search.value !== ''){
      // need to escape, JSON will error when search has a backslash
      search.value = UtilString.escapeSpecialChar(search.value);
    }

    if( isFiltered || search.value !== ''){
      this.dataTable.selectAllLabel = this.dataTable.SELECT_ALL_FILTERED_LABEL;
    }else{
      this.dataTable.selectAllLabel = this.dataTable.SELECT_ALL_LABEL;
    }

    const sortField = order.length > 0 ? this.dataTable.componentDefinition.gridColumns[ order[0].column ].field : undefined;

    if( this.dataTable.dataSource === 'docArray'){
      return fnCallback(this.fetchDocArray({draw, columns, order, start, length, search}));
    }
    if( this.dataTable.dataSource === 'dataArray'){
      return fnCallback(this.fetchDataArray({draw, columns, order, start, length, search}));
    }

    if( this.dataTable.excludeColumnSort.length > 0){
      order.forEach( (val, i) => {
        if(this.dataTable.excludeColumnSort.indexOf( this.dataTable.componentDefinition.gridColumns[val.column].field ) !== -1)
        {
          order[i].column = this.prevSort.column;
          order[i].dir = this.prevSort.dir;
        }
      });
    }

    const gridCols = [];
    for(const [i, cols] of this.dataTable.componentDefinition.gridColumns.entries()){
      gridCols.push({
        field: cols.field,
        type: cols.type ?? 'string',
        sort: cols.sort?.type ?? '',
        visible: !this.dataTable.componentDefinition.hiddenColumns.includes(i)
      });
    }

    const options = this.dataTable.searchOptions;
    // console.log("Original filter : "+this.componentDefinition.filter);

    // this.sclHandlebars.processHandlebars(this.componentDefinition.filter, this.docForHandlebars);
    // No Need for interpolate function as SearchService provides handlebars expansion

    let filterObj;
    try {

      let filter;
      let dexieFilter;
      try {
        // throws an error if template parsing fails instead of returning a null object:
        filter = this.handlebars.processHandlebarsV2(this.dataTable.componentDefinition.filter, this.dataTable.contextParams);
      } catch (err) {
        const {componentName, name} = this.dataTable.contextParams.componentDefinition;
        const error =
          new Error(`Handlebars parsing error at field named ${name} (${componentName}): ${err.message ? err.message : 'details n/a'}`);
        console.error(error);
        throw error;
      }

      if( !this.dataTable.componentDefinition.searchBoxFilter ){

        this.dataTable.componentDefinition.searchBoxFilter = JSON.stringify({
          query_string: {
            query: '*{{{search}}}*',
            analyze_wildcard:true,
            allow_leading_wildcard: true,
            default_operator: 'AND',
            analyzer: 'formbird_text_search'
          }
        });

      }else{

        const tmpSearchBoxFilter = JSON.parse(this.dataTable.componentDefinition.searchBoxFilter.replace(/'/g, '"'));

        if( !tmpSearchBoxFilter.query_string.default_operator ){
          tmpSearchBoxFilter.query_string.default_operator = 'AND';
        }
        if( !tmpSearchBoxFilter.query_string.analyzer ){
          tmpSearchBoxFilter.query_string.analyzer = 'formbird_text_search';
        }

        this.dataTable.componentDefinition.searchBoxFilter = JSON.stringify(tmpSearchBoxFilter);

      }

      let qryFunc = this.queryService.getElasticQuery;
      const searchProviderName = this.dataTable.searchClientService.getDefaultSearchProvider(this.dataTable);
      // const searchProviderName = this.config.clientConfig().defaultSearchProvider;

      if (searchProviderName === 'couchbase') {
        qryFunc = this.queryService.getCouchbaseQuery;
      } else if (searchProviderName === 'mongodb') {
        qryFunc = this.queryService.getMongoQuery;
      } else if (this.dataTable.searchClientService.isDexieQuery(this.dataTable)) {
        dexieFilter = this.queryService.getDexieQuery(this.dataTable, filter, search, columns, order, this.dataTable.dtcolumns);
      }
      if (!_.isEmpty(filter)){
        filterObj = qryFunc(this.dataTable, filter, search, columns, order, this.dataTable.dtcolumns);
      } else{
        filterObj = {};
      }

      if (dexieFilter) {
        if (dexieFilter.dexieQuery) {
          filterObj.dexieQuery = dexieFilter.dexieQuery;
        }
        if (dexieFilter.dexieSort) {
          filterObj.dexieSort = dexieFilter.dexieSort;
        }
      }

      // Creating reference object to the query_string
      const queryStringObject = filterObj.query.bool.must.find(obj => obj.query_string);

      if(queryStringObject){
        // any update on the queryStringObject will also update the filterObj
        // replacing whitespaces to '* *'
        queryStringObject.query_string.query = queryStringObject.query_string.query.replace(/\s+/g, '* *');
      }

      console.log('Post Sort Search JSON filter : ' + JSON.stringify(filterObj));

      this.dataTable.exportQuery = { ...filterObj };


      if (searchProviderName !== 'mongodb') {
        // Need to pass document to allow handlebars expansion
        if (pSelect !== true) {
          filterObj.from = start;
        }

        filterObj.size = (pSelect === true) ? 1000 : length;

      } else {
        options.from = start;
        options.size = (pSelect === true) ? 1000 : length;
      }

      // filterObj.size = 1000;
      options.document = this.dataTable.document;
      options.filter = filterObj;

      if( options.filter?.sort ) {
        options.filter.sort.push({'systemHeader.versionId': 'asc'});
        const orderCol = order[0]?.column ?? 0;
        const sortType = gridCols[orderCol].sort;

        if( sortType === 'caseInsensitive'){
          const colSort = columns[orderCol].name;
          logger.warn(`sc-datatable "${this.dataTable.fieldName}" warning - Case Insensitive sort is not available for dataService column "${colSort}" config ignored`);
        }
      } else {
        options.sort = [{'systemHeader.versionId': 'asc'}];
      }

      if (this.dataTable.searchOffline) {
        options.searchOfflineOnly = this.dataTable.searchOffline;
      }

      if (this.dataTable.includeDeleted) {
        options.includeDeleted = this.dataTable.includeDeleted;
      }

      if (this.dataTable.queryName) {
        options.dataSource =  this.dataTable.searchClientService.getDefaultSearchProvider(this.dataTable);
        options.queryName = this.dataTable.queryName;
        options.from = filterObj.from;
        options.size = filterObj.size;
      }

      options.disableHandlebars = true;
      const trackTotalHits = (this.dataTable.componentDefinition.esTrackTotalHits === undefined) ?
        true : this.dataTable.componentDefinition.esTrackTotalHits;
      options.searchProviderOptions = {
        track_total_hits: trackTotalHits
      };

      let searchAfter = null;
      const extendedPages = this.dataTable.pagination.extend;
      if( extendedPages && extendedPages.length > 0 ){
        searchAfter = this.dataTable.pagination.extend.filter(p => p.index === this.dataTable.pagination.current_page-1);
      }

      if ( searchAfter && searchAfter.length > 0 ) {
        options.searchAfter = searchAfter[0].search_after;
        delete options.from;
        delete options.filter.from;
      } else {
        delete options.searchAfter
      }


      this.dataTable.searchClientService.search(options)
        .then((results) => {
          const dataSet = [];

          if (pSelect === true) {
            this.dataTable.selectedDocumentsRel = [];
          }

          SearchResultsProcessor.processSearchResults(results, (itemData, sort) => {
            dataSet.push(itemData);
            if (pSelect === true) {
                this.dataTable.selectedDocumentsRel.push({
                  documentId: itemData.documentId,
                  name: itemData.systemHeader.summaryName
                });
            }
          }, (customData, totalHits, lastSort) => {
            const total = totalHits;
            this.dataTable.exportQuery.size = totalHits;

            if( lastSort ){
              this.prevSortScore = lastSort;
            }

            if (pSelect === true) {
              this.response = {
                draw,
                recordsTotal: total,
                recordsFiltered: total,
                data: dataSet,
                error: null
              };

            } else {
              this.dataTable.forcePageInfo = true;
              if (total === dataSet.length) {
                // compared it to `false` to avoid the undefined value getting true in the if condition
                if (this.dataTable.componentDefinition.forcePageInfo === false) {
                  this.dataTable.forcePageInfo = false;
                }
              }

              this.response = {
                draw,
                recordsTotal: total,
                recordsFiltered: total,
                data: dataSet,
                error: null
              };

              if (total > this.maxItems) {
                if (trackTotalHits) {
                  this.dataTable.trackTotalHitsLabel = '';
                } else {
                  this.dataTable.trackTotalHitsLabel = 'More than ';
                }
              }

              if (total > 0) {
                this.dataTable.hideNoData = false;
                this.dataTable.detectChanges();
              }
            }

            this.totalHits = total;

            this.prevSort = order[0];
            fnCallback(this.response);
          });
        })
        .catch(err => {
          // this.dataTable.notificationService.printMessage(err?.message || `Can't sort on this column as it has no values`, 'error');
          logger.error('sc-datatables: ' + (err?.message || `Can't sort on this column as it has no values`));

          this.totalHits = 0;
          const errObj = {
            draw,
            recordsTotal: 0,
            recordsFiltered: 0,
            data: [],
            // error:  err?.message || `Can't sort on this column as it has no values`,
            sort: sortField,
            prevResponse: this.response
          };

          fnCallback(errObj);
        });

    } catch (err) {
      // this.dataTable.notificationService.printMessage(err.message, 'error');
      logger.error('sc-datatables: ' + err?.message);

      const errObj = {
        draw,
        recordsTotal: 0,
        recordsFiltered: 0,
        data: [],
        sort: sortField,
        prevResponse: this.response
      };
      fnCallback(errObj);
    }
  }


  fetchDataArray( dtParams ){

    const {draw, columns, order, start, length, search, fnCallback} = dtParams;

    const gridCols = [];
    for(const cols of this.dataTable.componentDefinition.gridColumns){
      gridCols.push({
        field: cols.field,
        type: cols.type ?? 'string',
        sort: cols.sort?.type ?? ''
      });
    }

    let resultsArray = this.dataTable.contextParams.document[this.dataTable.componentDefinition.dataSourceName] ?? [];

    if(resultsArray.length === 0){
      resultsArray = this.dataTable.contextParams.template[this.dataTable.componentDefinition.dataSourceName] ?? [];
    }

    if( typeof resultsArray === 'string'){
      resultsArray  = JSON.parse(resultsArray);
    }

    let results = [];
    for(const [i, row] of resultsArray.entries()){
      if( Array.isArray(row)){
        const obj = {};
        for( const [key, colValue] of row.entries()){
            const colIndex = _.get(gridCols[key], 'field');
            obj[colIndex] = colValue
        }
        results.push(obj);
      }
    }

    // Filter Columns Search
    for( const col of columns ){
      if(col.search.value !== ''){
        results = results.map((item) => {
          if( _.get(item,col.name).toString().toLowerCase().indexOf(col.search.value.toLowerCase()) !== -1){
            return item;
          }
        }).filter(item => item);
      }
    }

    // Do Global Search
    if( search.value !== ''){
      results = results.map(items => {

        for( const [i, col] of columns.entries() ){
          if( gridCols[i].type !== 'date'){
            const item = _.get(items, col.data).toString();
            if( item ){
              if(item.toString().toLowerCase().indexOf(search.value.toLowerCase()) !== -1){
                return items;
              }
            }
          }
        }
      }).filter(item => item);
    }

    // Sort Results
    if( order.length > 0 ){
      const colSort = columns[order[0].column].name;
      const dir = order[0].dir;
      const sortType = gridCols[order[0].column].sort;

      if( dir !== ''){
        results = _.orderBy(results, [item => {
          const colData = _.get(item, colSort);

          if(typeof colData === 'string' && sortType === 'caseInsensitive'){
            return colData.toLowerCase();
          }
          return colData;
        }], [dir]);
      }
    }


    this.totalHits = results.length;
    const pageNum = Math.round(start/length) + 1;
    const data = this.paginate(results, length, pageNum );

    return {
      draw,
      recordsTotal: results.length,
      recordsFiltered: results.length,
      data,
      error: null
    };
  }


  fetchDocArray( dtParams ){

    const {draw, columns, order, start, length, search, fnCallback} = dtParams;

    const gridCols = [];
    for(const cols of this.dataTable.componentDefinition.gridColumns){
      gridCols.push({
        field: cols.field,
        type: cols.type ?? 'string',
        sort: cols.sort?.type ?? ''
      });
    }

    let results = [];
    if(this.dataTable.isSelectionView){
      results = this.dataTable.selectedDocumentSource ?? [];
    }else{
      results = this.dataTable.contextParams.document[this.dataTable.componentDefinition.dataSourceName] ?? [];
    }

    if( typeof results === 'string'){
      results = JSON.parse(results);
    }

    // Filter Columns Search
    for( const col of columns ){
      if(col.search.value !== ''){
        results = results.map((item) => {
          if( _.get(item,col.name).toString().toLowerCase().indexOf(col.search.value.toLowerCase()) !== -1){
            return item;
          }
        }).filter(item => item);
      }
    }

    // Do Global Search
    if( search.value !== ''){
      results = results.map(items => {

        for( const [i, col] of columns.entries() ){
          if( gridCols[i].type !== 'date'){
            const item = _.get(items, col.data);
            if( item ){
              if(item.toString().toLowerCase().indexOf(search.value.toLowerCase()) !== -1){
                return items;
              }
            }
          }
        }
      }).filter(item => item);
    }

    // Sort Results
    if( order.length > 0 ){
      const colSort = columns[order[0].column].name;
      const dir = order[0].dir;
      const sortType = gridCols[order[0].column].sort;

      if( dir !== ''){
        results = _.orderBy(results, [item => {
          const colData = _.get(item, colSort);

          if(typeof colData === 'string' && sortType === 'caseInsensitive'){
            return colData.toLowerCase();
          }
          return colData;
        }], [dir]);
      }
    }

    this.totalHits = results.length;
    const pageNum = Math.round(start/length) + 1;
    const data = this.paginate(results, length, pageNum );

    return {
      draw,
      recordsTotal: results.length,
      recordsFiltered: results.length,
      data,
      error: null
    };
  }

  paginate(array, pageSize, pageNumber) {
    // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
    return array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
  }


}
